import { useMemo } from "react";

import { Box, Stack, Theme, useMediaQuery } from "@mui/material";

import { Button, FileDownloadButton } from "@covertree/ui";
import { useCheckout } from "../CheckoutProvider";

interface Props {
  policyLocator: string;
}
export function QuoteDocumentsButtons({ policyLocator }: Props) {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  const { anythingLoading, documentsLoading, documents, getQuoteDocuments } =
    useCheckout();

  const areDocumentsGenerated = useMemo(
    () => documents?.applicationDocumentUrl && documents?.quoteProposalUrl,
    [documents]
  );

  return (
    <Box mt={3}>
      {!areDocumentsGenerated && (
        <Button
          loading={documentsLoading}
          variant="outlined"
          onClick={getQuoteDocuments}
          type="button"
          disabled={anythingLoading}
          fullWidth
          sx={
            !isDesktop
              ? (theme) => ({
                  height: theme.spacing(5),
                  "&.MuiButton-outlined": {
                    "&:hover": {
                      backgroundColor: "transparent",
                      color: theme.palette.grey[400],
                    },
                  },
                })
              : {}
          }>
          {documentsLoading
            ? "Preparing Quote Documents..."
            : "Generate Quote Documents"}
        </Button>
      )}
      {areDocumentsGenerated && (
        <Stack direction="column" spacing={2}>
          <FileDownloadButton
            label="Quote Proposal"
            fileName={`Quote Proposal - ${policyLocator}.pdf`}
            href={documents!.quoteProposalUrl}
          />
          <FileDownloadButton
            label="Policy Application"
            fileName={`Policy Application - ${policyLocator}.pdf`}
            href={documents!.applicationDocumentUrl}
          />
        </Stack>
      )}
    </Box>
  );
}
